var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "section-posts2 section-posts-list-view" },
    [
      _c(
        "div",
        { staticClass: "navigations" },
        [
          _c("div", { staticClass: "navigation-status" }, [
            _c(
              "div",
              {
                staticClass: "btn-radius",
                class: { active: _vm.statusIsAllSelected },
                on: { click: () => _vm.clickStatusEvent("all") },
              },
              [_vm._v(_vm._s(_vm.$t("dash.posts.status.all")))]
            ),
            _c(
              "div",
              {
                staticClass: "btn-radius",
                class: {
                  active:
                    !_vm.statusIsAllSelected && _vm.filter.statusDisplay.draft,
                },
                on: { click: () => _vm.clickStatusEvent("draft") },
              },
              [_vm._v(_vm._s(_vm.$t("dash.post.draft")))]
            ),
            _c(
              "div",
              {
                staticClass: "btn-radius",
                class: {
                  active:
                    !_vm.statusIsAllSelected &&
                    _vm.filter.statusDisplay.scheduled,
                },
                on: { click: () => _vm.clickStatusEvent("scheduled") },
              },
              [_vm._v(_vm._s(_vm.$t("dash.post.scheduled")))]
            ),
            _c(
              "div",
              {
                staticClass: "btn-radius",
                class: {
                  active:
                    !_vm.statusIsAllSelected && _vm.filter.statusDisplay.posted,
                },
                on: { click: () => _vm.clickStatusEvent("posted") },
              },
              [_vm._v(_vm._s(_vm.$t("dash.post.posted")))]
            ),
            _vm.statusHideSelected.length
              ? _c(
                  "div",
                  {
                    staticClass:
                      "btn-radius active count-other-status-selected",
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        _vm.filterIsOpen = true
                      },
                    },
                  },
                  [
                    _c("i", { staticClass: "fa-solid fa-plus" }),
                    _vm._v(_vm._s(_vm.statusHideSelected.length)),
                  ]
                )
              : _vm._e(),
            _c(
              "div",
              {
                staticClass: "btn-radius icon",
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                    _vm.filterIsOpen = true
                  },
                },
              },
              [_c("i", { staticClass: "fa-solid fa-plus" })]
            ),
          ]),
          _c("div", { staticClass: "navigation-filter" }, [
            _c("div", { staticClass: "btn-radius search-bar" }, [
              _c("div", { staticClass: "svg" }, [
                _c(
                  "svg",
                  {
                    attrs: {
                      xmlns: "http://www.w3.org/2000/svg",
                      width: "21",
                      height: "21",
                      viewBox: "0 0 21 21",
                      fill: "none",
                    },
                  },
                  [
                    _c("path", {
                      attrs: {
                        d: "M17.0625 8.53125C17.0625 10.4139 16.4514 12.1529 15.4219 13.5639L20.6145 18.7605C21.1271 19.2732 21.1271 20.1059 20.6145 20.6186C20.1018 21.1312 19.2691 21.1312 18.7564 20.6186L13.5639 15.4219C12.1529 16.4555 10.4139 17.0625 8.53125 17.0625C3.81855 17.0625 0 13.2439 0 8.53125C0 3.81855 3.81855 0 8.53125 0C13.2439 0 17.0625 3.81855 17.0625 8.53125ZM8.53125 14.4375C9.30687 14.4375 10.0749 14.2847 10.7915 13.9879C11.5081 13.6911 12.1592 13.256 12.7076 12.7076C13.256 12.1592 13.6911 11.5081 13.9879 10.7915C14.2847 10.0749 14.4375 9.30687 14.4375 8.53125C14.4375 7.75563 14.2847 6.9876 13.9879 6.27103C13.6911 5.55445 13.256 4.90335 12.7076 4.3549C12.1592 3.80645 11.5081 3.3714 10.7915 3.07459C10.0749 2.77777 9.30687 2.625 8.53125 2.625C7.75563 2.625 6.98761 2.77777 6.27103 3.07459C5.55445 3.3714 4.90335 3.80645 4.3549 4.3549C3.80645 4.90335 3.3714 5.55445 3.07459 6.27103C2.77777 6.9876 2.625 7.75563 2.625 8.53125C2.625 9.30687 2.77777 10.0749 3.07459 10.7915C3.3714 11.5081 3.80645 12.1592 4.3549 12.7076C4.90335 13.256 5.55445 13.6911 6.27103 13.9879C6.98761 14.2847 7.75563 14.4375 8.53125 14.4375Z",
                        fill: "#E3D2EE",
                      },
                    }),
                  ]
                ),
              ]),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model.lazy",
                    value: _vm.filter.search,
                    expression: "filter.search",
                    modifiers: { lazy: true },
                  },
                ],
                attrs: { placeholder: _vm.$t("dash.posts.list.search") },
                domProps: { value: _vm.filter.search },
                on: {
                  change: function ($event) {
                    return _vm.$set(_vm.filter, "search", $event.target.value)
                  },
                },
              }),
            ]),
            _c(
              "div",
              {
                staticClass: "btn-radius",
                attrs: { "data-count": _vm.filterCount },
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                    _vm.filterIsOpen = true
                  },
                },
              },
              [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("dash.posts.list.filter")) +
                    "\n                "
                ),
                _vm.filterIsOpen
                  ? _c("FilterNavigation", {
                      attrs: {
                        filter: _vm.filter,
                        hideSearchBar: true,
                        showDateRange: true,
                      },
                      on: {
                        close: _vm.onFilterClose,
                        "update:filter": function ($event) {
                          _vm.filter = $event
                        },
                      },
                    })
                  : _vm._e(),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "btn-radius icon", on: { click: _vm.fetchPost } },
              [_c("i", { staticClass: "fa-solid fa-rotate-right" })]
            ),
          ]),
          _c(
            "MainNavigation",
            _vm._g({ attrs: { tabSelected: _vm.tabSelected } }, _vm.$listeners)
          ),
        ],
        1
      ),
      _vm.isLoading || _vm.isLoadingMore
        ? _c("div", { staticClass: "loading-overlay fixed" }, [
            _c("i", { staticClass: "fa-sharp fa-solid fa-spinner-third" }),
            _vm._v(_vm._s(_vm.$t("dash.posts.list.loading"))),
          ])
        : _vm._e(),
      _c(
        "div",
        { staticClass: "list-posts" },
        [
          _vm._l(_vm.eventsFilter, function (event) {
            return _c(
              "div",
              {
                key: event.id,
                staticClass:
                  "item-post carousel card-status-background-color card-status-border-color card-status-border-style-default hover-card-status-background-color",
                class: event.status,
                on: { click: () => _vm.handleEventClick(event.id) },
              },
              [
                _c("div", { staticClass: "container-badge-status" }, [
                  _c(
                    "div",
                    {
                      staticClass: "badge-status",
                      attrs: { status: event.status },
                    },
                    [_vm._v(_vm._s(_vm.$t(`dash.post.${event.status}`)))]
                  ),
                ]),
                _c("div", { staticClass: "post-content" }, [
                  event.image
                    ? _c(
                        "div",
                        { staticClass: "post-image", class: event.type },
                        [
                          _c("img", { attrs: { src: event.image } }),
                          _c("div", {
                            staticClass: "type-post",
                            class: event.type,
                          }),
                        ]
                      )
                    : _vm._e(),
                  _c("div", { staticClass: "container-info-text" }, [
                    _c("div", { staticClass: "container-date" }, [
                      _c("p", { staticClass: "date" }, [
                        _vm._v(_vm._s(event.formatedDate)),
                      ]),
                    ]),
                    _c("p", { staticClass: "content" }, [
                      _vm._v(
                        "\n                        " +
                          _vm._s(event.content) +
                          "\n                    "
                      ),
                    ]),
                  ]),
                ]),
                _c(
                  "div",
                  { staticClass: "pages" },
                  [
                    _c(
                      "Tooltip",
                      { attrs: { text: _vm.getPage(event.page.id).name } },
                      [
                        _c("Avatar", {
                          key: event.page.id,
                          attrs: {
                            urlPicture: event.page.avatar,
                            typeNetwork: event.page.network,
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            )
          }),
          _c("div", { ref: "sentinel", staticClass: "sentinel" }),
        ],
        2
      ),
      _vm.eventIdSelected
        ? _c("DrawerPost", {
            attrs: { event: _vm.events[_vm.eventIdSelected] },
            on: { close: _vm.closeDrawer, deletePost: _vm.handlerDeletePost },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }